const allproject = { data: [], loading: true };
const allcrmproject = { data: [], loading: true };
const allprojectsearch = { data: [], loading: true };

export const GetAllProject = (state = allproject, action) => {
  switch (action.type) {
    case "get_allproject":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetAllCRMProject = (state = allcrmproject, action) => {
  switch (action.type) {
    case "get_allcrmproject":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetAllProjectSearch = (state = allprojectsearch, action) => {
  switch (action.type) {
    case "get_allprojectsearch":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
